<template>
  <div>
     <v-row
    align="center"
    v-if="(isPromo && detallePromocion(codArt).length!=0) && dataUser.IndAutenticado"
  >
    <v-menu
      v-model="menu"
      @keyup.esc="menu = false"
      bottom
      right
      transition="scale-transition"
      origin="top left"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on }">
        <v-chip
          label
          v-on="on"
          small
          @click.stop="cargarPromo(codArt)"
          color="white"
          :class="[
                          $vuetify.breakpoint.mdAndUp
                            ? 'text-uppercase font-weight-regular body-2 mt-2 ml-0'
                            : 'text-uppercase font-weight-bold body-2 mt-2 ml-0',
                        ]"
     
        >
          Ver Promoción
        </v-chip>
      </template>
      <v-card width="350" 
      elevation="0"
      :loading="detallePromocion(codArt).length===0 ? '#fe5000' : null"
      >
        <v-toolbar color="primary" dark dense height="28" elevation="0">
          <v-container>
            <v-layout row>
              <span :class="['font-weight-bold', 'body-2', 'mx-auto']"
                >{{codArt}} PROMOCIÓN</span
              >
            </v-layout>
          </v-container>
          <v-spacer></v-spacer>
          <v-btn 
          icon 
          @click="menu = false" 
          dark
          >
            <v-icon >mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
 
     <v-progress-linear
      indeterminate
       height="10"
       rounded
        color="accent"
       v-if="filterpromo.length===0 "
    ></v-progress-linear>
        <v-list v-else 
        v-for="(item, i) in detallePromocion(codArt)" 
        :key="i">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title
                >Cantidad Minima:
                <span class="font-weight-bold">
                  {{  `${item["cantidad-min"]/item["ContenidoMayor"]} ${validaContenido ? 'Paleta' : ' Uni'}` }}</span
                >
                <span class="text--secondary"> |</span>
                Dto:
                <span class="font-weight-bold"
                  >{{ ` ${item["descuento"]}%` }}
                </span></v-list-item-title
              >
              <v-list-item-title
                class="body-1"
                v-if="dataUser.VerPrecios[tipoMoneda]"
              >
                Precio:
                <span class="font-weight-bold"
                  >{{ `${simboloMoneda[tipoMoneda]}` }}
                  {{ item["PrecioExt-paq"] | numeral("0,0.00") }}
                </span>
                <span class="text--secondary">|</span>
                Ahorre:
                <span
                  class="font-weight-bold"
                  v-if="dataUser.VerPrecios[tipoMoneda]"
                  >{{ `${simboloMoneda[tipoMoneda]}` }}
                  {{ item["MontoExtDes"] | numeral("0,0.00") }}</span
                >
              </v-list-item-title>
              <v-divider color="#D3BC8D" />
              <v-list-item-subtitle class="mt-2">
                <btnPromo
                  @sel-promo="datosPromo"
                  :codArt="codArt"
                  :codPromo="item.codigo"
                  :tipoConsulta="1"
                  :titulo="`Cargar Promoción`"
                  :infoproducto="infoproducto"
                >
                </btnPromo>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </v-row>
  <v-chip
  v-else
      class="mx-1"
      x-small
    >
      Cargando Promoción...
    </v-chip>


  </div>
 
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import btnPromo from "../components/botonselpromo";
export default {
  data() {
    return {
      menu: false,
      promoDetalle: [],
    };
  },
  computed: {
    ...mapState([
      "PromocionAll",
      "Cliente",
      "simboloMoneda",
      "tipoMoneda",
      "dataUser",
      "TipoUsuario",
    ]),
    ...mapGetters(["filterpromo"]),
    detallePromocion: function () {
      //articulo
      return function (id) {
        if (this.filterpromo) {
          return this.filterpromo.filter((x) => id === x["articulo"]);
        }
      };
    },
    validaContenido() {
      const { ContentDetal } = this.infoproducto;
      return ContentDetal !== 1;
    },
    isPromocion: function () {
      //articulo
      return function (id) {
        if (this.filterpromo) {
          return this.filterpromo.length;
        }
      };
    },
  },
  methods: {
    ...mapActions(["cargarDatosPromo"]),
    ...mapMutations(["CLR_PROMO"]),
    datosPromo(datos) {
      this.promoDetalle = datos;
    },
    cargarPromo(cod) {
      // this.cargarDatosPromo({ codart: cod });
      //console.log(cod);
    },
  },
  components: {
    btnPromo,
  },
  props: {
    isPromo: Boolean,
    codArt: String,
    infoproducto: Object | Array,
  },
};
</script>

<style>
</style>